import { useEffect, useState, useMemo } from "react";
import moment from "moment";
import _ from "lodash";
import { Form, Button } from "react-bootstrap";
import {
  getCoachingRequestUpdate,
  getCoachingRequestUpdateClear,
  getSlots,
  rescheduleSlots,
  rescheduleSlotsClear,
} from "../../../../redux/coaching/actions";

import { useDispatch, useSelector } from "react-redux";
import {
  ProductCardPriceInfo,
  scrollIntoViewWithOffset,
  SessionKeys,
} from "../../../../utils/AppUtils";

import ShimmerScreen from "../../../Layouts/ShimmerScreen";
import { useTranslation } from "react-i18next";

import Loader from "../../../Loader/Loader";
import FormButtonComponent from "../../FormControl/FormButton/FormButtonComponent";
import { RightArrowIcon } from "../../../../utils/SvgComps";
import { cartPageDataResponse, coachOrServiceIdDataResponse } from "../../../../redux/checkout/actions";
import { routeList } from "../../../../utils/routeList";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Slider from "react-slick";
import { Rating } from "@mui/material";
import CoachingServiceRequestForm from "./CoachingServiceRequestForm";
const SlotBookingModal = (props) => {
  const {
    currencyCode,
    currencySymbol,
    sellingPrice,
    coachId,
    productId,
    coachesData,
    showForm,
    priceInfo,
    rescheduleFlag,
    showCancel,
    setShow,
    serviceSlots,
    masterPriceId,
    setCongratsModal,
    participantId,
    sessionId,
    is_new_slot,
    serviceCode
  } = props;

  useEffect(() => {
    console.log("service slots--", serviceSlots);
  }, [serviceSlots]);

  const [selectedCoach, setSelectedCoach] = useState(coachId);
  const [formVisibility, setFormVisibility] = useState(showForm);
  const [selectedServiceSlot, setSelectedServiceSlot] = useState();

  useEffect(() => {
    console.log("selectedServiceSlot-", selectedServiceSlot);
    if (_.toInteger(selectedServiceSlot) === 1) {
      setFormVisibility(false);
    } else {
      setFormVisibility(true);
    }
  }, [selectedServiceSlot]);

  const settings1 = {
    arrows: true,
    dots: false, // Display navigation dots
    infinite: false, // Loop the slides infinitely
    speed: 500, // Animation speed in milliseconds
    slidesToShow: 3, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll at a time
    autoplay: false, // Autoplay slides
    autoplaySpeed: 3000, // Autoplay interval in milliseconds
    centerMode: false, // Prevents centering
    centerPadding: 0, // Removes extra spacing
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const navigate = useNavigate();
  const c = params.get("c");
  // let decodedString = atob(c);
  // let paramsReq = JSON.parse(decodedString);
  // const selectedCoachId = paramsReq.coach_id;
  // const price = paramsReq.price;
  // const currencyCode = paramsReq.currency_code;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const sessionDetails = useSelector((state) => state.coaching.getSlotsData);
  const userDetailRes = useSelector((state) => state.user.userBroker);
  let rescheduleDetails = useSelector(
    (state) => state.coaching.rescheduleSlotsData
  );

  const coachingRequestUpdateRes = useSelector(
    (state) => state.coaching.coachingRequestUpdateData
  );

  const [filteredSlotsData, setFilteredSlotsData] = useState([]);
  const [allSlotsData, setAllSlotsData] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(serviceSlots)) {
      setSelectedServiceSlot(serviceSlots[0]?.price_id);
    }
  }, [serviceSlots]);

  const [error, setError] = useState("");
  const [slotsApiCalled, setSlotsApiCalled] = useState(false);

  const [activeSlot, setActiveSlot] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [rescheduleLoading, setRescheduleLoading] = useState(false);

  const [selectedDate, setSelectedDate] = useState(
    moment().format("MMMM YYYY")
  );
  const [date, setDate] = useState(moment());

  const [currentMonth2, setCurrentMonth2] = useState(
    moment().format("MMMM YYYY")
  );
  const [submitMessage, setSubmitMessage] = useState("");
  const [loader, setLoader] = useState(false);
  const [selectedHours, setSelectedHours] = useState("");
  const [checkoutLoader, setCheckoutLoader] = useState(false);
  useEffect(() => {
    setLoader(false);
    console.log("selected slot---", activeSlot);
    let totalHours = 0;

    activeSlot.forEach((slot) => {
      const startTime = parseInt(slot.start_time);
      const endTime = parseInt(slot.end_time);

      const timeDiff = endTime - startTime;
      const hoursDiff = timeDiff / 3600; // convert seconds to hours

      totalHours += hoursDiff;
    });

    console.log("selected slot---hours", totalHours);
    setSelectedHours(totalHours);
  }, [activeSlot]);

  useEffect(() => {
    if (!showForm) {
      setDate(moment());
      setSelectedDate(moment().format("MMMM YYYY"));
      getSessionData();
    }
  }, [selectedCoach]);

  useEffect(() => {
    console.log("sessionDetails", sessionDetails);
    console.log("slotsApiCalled", slotsApiCalled);
    if (!_.isEmpty(sessionDetails) && slotsApiCalled) {
      if (sessionDetails?.status === "success") {
        const slotArr = sessionDetails?.payload?.payload;
        const timezoneAbbr =
          userDetailRes?.payload?.payload?.timezoneAbbr || "Europe/London";
        // Extract slot data
        console.log("slotArr1", slotArr);
        console.log("current month first time", selectedDate, date);

        if (Array.isArray(slotArr)) {
          let sortedSlots = slotArr.sort(
            (a, b) => new Date(a.date) - new Date(b.date)
          );
          sortedSlots = sortedSlots.map((slotData) => {
            slotData.slot = slotData.slot.map((slot) => {
              slot.self_booked =
                slot?.user?.user_id ==
                localStorage.getItem(SessionKeys.USER_ID);
              return slot;
            });
            return slotData;
          });

          setAllSlotsData(sortedSlots);
          const selectedMonthData = sortedSlots.filter((data) => {
            const date = moment(data.date);
            const currentDateTime = moment().tz(timezoneAbbr);
            data.slot = data.slot.filter((slot) => {
              const slotDate = moment.unix(slot.start_time).tz(timezoneAbbr);
              if (!slot.is_booking || slot.self_booked)
                return slotDate.isSameOrAfter(currentDateTime);
            });

            const month = date.format("MMMM YYYY");
            return (
              month === moment().format("MMMM YYYY") && !_.isEmpty(data.slot)
            );
          });
          console.log("FILTERED SLOTS DATA", selectedMonthData);
          setFilteredSlotsData(selectedMonthData);
        } else {
          console.error("Slots data is not an array:", slotArr);
          setFilteredSlotsData([]);
        }
      } else {
        console.error("Failed to fetch slots.");
        setFilteredSlotsData([]);
        setIsFetching(false);
      }
      setIsFetching(false);
      setSlotsApiCalled(false);
    }
  }, [sessionDetails, userDetailRes]);

  const getSessionData = () => {
    setSlotsApiCalled(true);
    setIsFetching(true);
    dispatch(
      getSlots({
        module: "getSlotsModule",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          coach_id: selectedCoach,
        },
      })
    );
  };

  useEffect(() => {
    const selectedMonthData = allSlotsData.filter((data) => {
      const date = moment(data.date);
      const month = date.format("MMMM YYYY");
      return month === selectedDate && !_.isEmpty(data.slot);
    });
    console.log(
      "selected month data----",
      filteredSlotsData,
      selectedMonthData,
      selectedDate
    );
    setFilteredSlotsData(selectedMonthData);
  }, [selectedDate]);

  const handlePreviousMonth = () => {
    setDate(date.clone().subtract(1, "month"));
    setSelectedDate(date.clone().subtract(1, "month").format("MMMM YYYY"));
  };

  const handleNextMonth = () => {
    setDate(date.clone().add(1, "month"));
    setSelectedDate(date.clone().add(1, "month").format("MMMM YYYY"));
  };

  // const handleError = () => {
  //   // Set the error message
  //   setError(t("pleaseSelectValidSessionBeforeBooking"));

  //   // Clear the error message after 5 seconds
  //   setTimeout(() => {
  //     setError("");
  //   }, 5000);
  // };

  const [preferredSlotData, setPreferredSlotData] = useState([
    { id: "1", label: "Morning" },
    { id: "2", label: "Afternoon" },
    { id: "3", label: "Evening" },
  ]);
  const [selectedPreferredSlot, setSelectedPreferredSlot] = useState("");
  const [selectedPreferredDate, setSelectedPreferredDate] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [dateError, setDateError] = useState("");
  const [remarksError, setRemarksError] = useState("");
  const [remarks, setRemarks] = useState("");

  const getSlotClass = (dayData, slot) => {
    return activeSlot.some((item) => item.id === slot.id) ? "active-page" : "";
  };

  useEffect(() => {}, [formVisibility]);

  useEffect(() => {
    if (!_.isEmpty(selectedPreferredSlot)) {
      setErrorMsg("");
    }
  }, [selectedPreferredSlot]);

  useEffect(() => {
    console.log("s-e",selectedPreferredDate);
    if (!_.isEmpty(selectedPreferredDate)) {
      setDateError("");
    }
  }, [selectedPreferredDate]);

  useEffect(() => {
    if (!_.isEmpty(remarks)) {
      setRemarksError("");
    }
  }, [remarks]);

  const redirectTo = () => {
    console.log(
      "cond---",
      showForm,
      !selectedPreferredSlot,
      !remarks,
      selectedPreferredDate
    );
    if (
      formVisibility &&
      (!selectedPreferredSlot || !remarks || !selectedPreferredDate)
    ) {
      if (!selectedPreferredDate) {
        setDateError(t("Please select preferred date"));
      }
      if (!selectedPreferredSlot) {
        setErrorMsg(t("Please select preferred slot"));
      }
      if (!remarks) {
        setRemarksError(t("Please provide remarks"));
      }
    } 
    // else if (formVisibility && remarks?.length < 10) {
    //   setRemarksError(t("Remarks should be at least 10 characters"));
    // } 
    else {
      setCheckoutLoader(true);
      console.log("coach_id--", selectedCoach, productId);
      let slot_ids = activeSlot.map((item) => item?.id);

      dispatch(
        cartPageDataResponse({
          load: true,
          productId: productId,
          slot_ids: slot_ids,
          coach_id: selectedCoach,
          preferred_time: selectedPreferredSlot,
          remark: remarks,
          preferred_date: selectedPreferredDate,
          hour: selectedServiceSlot,
          serviceCode: serviceCode ? serviceCode : ""
        })
      ); // product id and slot id, slot quantity
      dispatch(coachOrServiceIdDataResponse({
        coach_id: selectedCoach,
        serviceCode: serviceCode ? serviceCode : ""
      }))
      setLoader(true);
      setTimeout(() => {
        navigate(routeList.PAYMENT_PAGE_PRODUCT, {
          state: { isMobile: false },
        });
      }, 2000);
    }
  };
  // const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCoachSelection = (id) => {
    setSelectedCoach(id);
  };

  useEffect(() => {
    console.log("rescheduleDetails", rescheduleDetails);

    if (!_.isEmpty(rescheduleDetails)) {
      if (rescheduleDetails?.status === "success") {
        const rescheduleArr = rescheduleDetails?.payload?.payload;

        // Extract slot data
        console.log("rescheduleArr1", rescheduleArr);
        dispatch(rescheduleSlotsClear());
        // onCloseModal();
        setSubmitMessage(
          "Your session reschedule request has been submitted successfuly."
        );
        setRescheduleLoading(false);
        setShow(false);
        setCongratsModal(true);
        rescheduleDetails = [];
        // setConfirmModal(true);
      }
    }
  }, [rescheduleDetails]);

  const rescheduleSlotsfunction = () => {
    console.log(
      "rescheduleSlots",
      activeSlot[0]?.start_time,
      activeSlot[0].end_time
    );
    setRescheduleLoading(true);

    if (is_new_slot) {
      dispatch(
        getCoachingRequestUpdate({
          module: "coachingRequestUpdate",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            id: sessionId,
            status: "reject_new_slot",
            start_time: activeSlot[0]?.start_time,
            end_time: activeSlot[0]?.end_time,
            slot_id: activeSlot[0]?.id,
          },
        })
      );
    } else {
      dispatch(
        rescheduleSlots({
          module: "rescheduleSlot",
          postData: {
            token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
            request_to: participantId ? participantId : selectedCoach, // either coach id or participant id
            entity_id: sessionId ? sessionId : activeSlot[0]?.coaching_id, // coaching_id will get from get-slots API
            request_type: "reschedule",
            // hour: 1,
            // remark: "I need to learn ai for four hour.",
            start_time: activeSlot[0]?.start_time,
            end_time: activeSlot[0]?.end_time,
            slot_id: activeSlot[0]?.id, //slot_id
          },
        })
      );
    }
  };

  useEffect(() => {
    if (!_.isEmpty(coachingRequestUpdateRes)) {
      if (coachingRequestUpdateRes?.status === "success") {
        console.log("coachingRequestUpdateRes", coachingRequestUpdateRes);

        setSubmitMessage(
          "Your session new slot request has been submitted successfuly."
        );
        dispatch(getCoachingRequestUpdateClear());
        dispatch(rescheduleSlotsClear());
        setRescheduleLoading(false);
        setShow(false);
        setCongratsModal(true);
      } else {
        setRescheduleLoading(false);
      }
    }
  }, [coachingRequestUpdateRes]);

  return (
    <>
      <Loader start={rescheduleLoading} />

      {!_.isEmpty(coachesData) ? (
        <>
          <div className="d-flex justify-content-between gap-3">
            <h3 className="mb-0">{t("Available Coaches")}</h3>
          </div>
          <div className="sliderse w-100 mb-3">
            <Slider {...settings1}>
              {coachesData?.map((item, index) => (
                <div
                  className={`coach-box cursor-pointer ${
                    selectedCoach === item?.coach_id ? "selected-block" : ""
                  }`}
                  onClick={() => handleCoachSelection(item?.coach_id)}
                >
                  <div className="above-info">
                    <div className="img-box-caoch">
                      <img
                        src={
                          item?.profile_image
                            ? item?.profile_image
                            : "https://cdnstg.training.com/halifax/image/10543/2058509172-20241212.png"
                        }
                        className="img-fluid"
                        alt=""
                      />
                      <div className="overlay-box-ino d-flex justify-content-between">
                        {!_.isEmpty(item?.user_industry) && (
                          <div className="infobox">
                            {item?.user_industry[0]}
                          </div>
                        )}
                        {!_.isEmpty(item?.experience) && (
                          <div className="infobox">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="15"
                              viewBox="0 0 14 15"
                              fill="none"
                            >
                              <g clip-path="url(#clip0_935_21063)">
                                <path
                                  d="M2.04761 10.502V14.6625H11.8704V10.502H2.04761Z"
                                  fill="#4D5E80"
                                />
                                <path
                                  d="M6.95898 10.502H11.8704V14.6625H6.95898V10.502Z"
                                  fill="#3D4566"
                                />
                                <path
                                  d="M6.5498 10.979H7.36838V12.2069H6.5498V10.979Z"
                                  fill="#FFDF40"
                                />
                                <path
                                  d="M6.95898 10.979H7.36827V12.2069H6.95898V10.979Z"
                                  fill="#FFBE40"
                                />
                                <path
                                  d="M9.00545 7.70463H8.18688V6.74502C7.91274 6.63658 7.42902 6.47677 6.95902 6.47677C6.48914 6.47677 6.0055 6.6365 5.73117 6.74505V7.70463H4.9126V6.22381L5.13885 6.11068C5.1758 6.09221 6.05423 5.6582 6.95902 5.6582C7.86381 5.6582 8.74225 6.09221 8.77919 6.11068L9.00545 6.22381V7.70463Z"
                                  fill="#4D5E80"
                                />
                                <path
                                  d="M8.18684 6.74502V7.70463H9.00541V6.22381L8.77916 6.11068C8.74221 6.09221 7.86378 5.6582 6.95898 5.6582V6.47677C7.42898 6.47677 7.9127 6.63658 8.18684 6.74502Z"
                                  fill="#3D4566"
                                />
                                <path
                                  d="M11.8704 7.29541V10.502L6.95903 11.3951L2.04761 10.502V7.29541H11.8704Z"
                                  fill="#3D4566"
                                />
                                <path
                                  d="M11.8704 7.29541H6.95898V11.3951L11.8704 10.502V7.29541Z"
                                  fill="#2E2E4D"
                                />
                                <path
                                  d="M3.57527 6.55573L2.20965 6.12819L0.844027 6.55573L0.828638 5.12484L0 3.95816L1.35612 3.50135L2.20965 2.35278L3.06317 3.50135L4.41929 3.95816L3.59068 5.12484L3.57527 6.55573Z"
                                  fill="#FFDF40"
                                />
                                <path
                                  d="M5.59351 4.91852L5.57812 3.48764L4.74951 2.32096L6.10564 1.86414L6.95916 0.715576L7.81265 1.86414L9.16878 2.32096L8.34017 3.48764L8.32481 4.91855L6.95916 4.49101L5.59351 4.91852Z"
                                  fill="#FFDF40"
                                />
                                <path
                                  d="M13.1561 6.55576L11.7904 6.12822L10.4248 6.55576L10.4094 5.12484L9.58081 3.95816L10.9369 3.50135L11.7904 2.35278L12.6439 3.50135L14 3.95816L13.1714 5.12484L13.1561 6.55576Z"
                                  fill="#FFDF40"
                                />
                                <path
                                  d="M8.32463 4.91852L8.33999 3.48761L9.1686 2.32096L7.81248 1.86414L6.95898 0.715576V4.49098L8.32463 4.91852Z"
                                  fill="#FFBE40"
                                />
                                <path
                                  d="M13.1559 6.55573L13.1713 5.12484L13.9999 3.95816L12.6438 3.50135L11.7903 2.35278V6.12819L13.1559 6.55573Z"
                                  fill="#FFBE40"
                                />
                                <path
                                  d="M3.57536 6.55573L3.59075 5.12484L4.41936 3.95816L3.06324 3.50135L2.20972 2.35278V6.12819L3.57536 6.55573Z"
                                  fill="#FFBE40"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_935_21063">
                                  <rect
                                    width="14"
                                    height="14"
                                    fill="white"
                                    transform="translate(0 0.688965)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>{" "}
                            Exp {item?.experience}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="caoch-info">
                      <div className="flex">
                        <h4 className="coach-tiele">{item?.display_name}</h4>
                        <div className="coach-desx">
                          <p>
                            {item?.user_skill?.map((skill, index) => {
                              console.log("check---", item, index);
                              if (
                                _.toNumber(item?.user_skill.length - 1) ===
                                _.toNumber(index)
                              ) {
                                return skill;
                              } else {
                                return `${skill},${" "}`;
                              }
                            })}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="foddd w-100">
                    <div className="key-skills-coach">
                      <p>
                        <strong>{t("Ratings")}</strong>
                      </p>
                      <div className="d-flex align-items-center gap-3">
                        <div>
                          <strong>{item?.ratings}</strong>
                        </div>
                        <div>
                          <Rating
                            name="half-rating"
                            value={item?.ratings}
                            precision={0.5}
                            readOnly={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </>
      ) : (
        ""
      )}

      {/* <div className="sep mt-3 mb-3"></div> */}
      {!formVisibility || rescheduleFlag ? (
        <div className="container-slot w-100 mt-3">
          <div className="pb-3 d-flex justify-content-between flex-md-row flex-column">
            <div className="d-flex align-items-md-center justify-content-between flex-md-row flex-column gap-4">
              <div className="mentor-title mb-0">
                {t("bookYourSessionFromAvailableSlots")}
              </div>
              <div className="d-flex cal_iconLR cal-btn-black align-items-center justify-content-end">
                <button
                  className="button-reset cursor-pointer"
                  onClick={() => handlePreviousMonth()}
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="14" cy="14" r="13.5" stroke="#415385" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.1918 18.3752C14.9625 18.3752 14.7342 18.286 14.5627 18.1083L11.1825 14.6083C10.8518 14.2645 10.8562 13.7193 11.1939 13.3816L14.6939 9.88159C15.0352 9.53947 15.589 9.53947 15.9312 9.88159C16.2724 10.2237 16.2724 10.7767 15.9312 11.1188L13.0393 14.0107L15.8209 16.8921C16.1569 17.2403 16.1473 17.7942 15.7999 18.1293C15.6293 18.2938 15.4105 18.3752 15.1918 18.3752Z"
                      fill="#415385"
                    />
                  </svg>
                </button>
                <p className="calen">{selectedDate}</p>
                <button
                  className="button-reset cursor-pointer"
                  onClick={() => handleNextMonth()}
                >
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="14"
                      cy="14"
                      r="13.5"
                      transform="rotate(180 14 14)"
                      stroke="#415385"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.8082 9.62478C13.0375 9.62478 13.2658 9.71403 13.4373 9.89166L16.8175 13.3917C17.1482 13.7355 17.1438 14.2807 16.8061 14.6184L13.3061 18.1184C12.9648 18.4605 12.411 18.4605 12.0688 18.1184C11.7276 17.7763 11.7276 17.2233 12.0688 16.8812L14.9607 13.9893L12.1791 11.1079C11.8431 10.7597 11.8527 10.2058 12.2001 9.87066C12.3707 9.70616 12.5895 9.62478 12.8082 9.62478Z"
                      fill="#415385"
                    />
                  </svg>
                </button>
              </div>
            </div>
            {serviceSlots?.length > 1 && (
              <div className="ms-auto">
                <select
                  className="form-select input_searchfield ps-3 p-2 pe-5 rounded-pill"
                  onChange={(ev) => setSelectedServiceSlot(ev.target.value)}
                  value={selectedServiceSlot}
                >
                  {serviceSlots.map((ex, index) => {
                    return (
                      <option
                        value={ex?.price_id}
                        selected={
                          selectedServiceSlot === ex?.price_id ? true : false
                        }
                        key={index}
                      >
                        {ex?.slot_type}
                      </option>
                    );
                  })}
                </select>
              </div>
            )}
          </div>
          <div className="slotparent">
            <div className="wrapper-calds">
              <div className="containertabs">
                {isFetching ? (
                  <>
                    <div className="listbox d-flex align-items-start">
                      <div
                        className="dtebx date-header text-center d-flex gap-2 flex-column"
                        style={{ background: "none" }}
                      >
                        {[0, 1, 2, 3, 4].map((slot) => (
                          <>
                            <ShimmerScreen
                              case="rect"
                              height="2rem"
                              width="2rem"
                            />
                          </>
                        ))}
                      </div>
                      <div className="datslot-box">
                        {[0, 1, 2, 3, 4].map((slot) => (
                          <>
                            <ShimmerScreen
                              case="rect"
                              height="2.5rem"
                              width="100%"
                            />
                          </>
                        ))}
                      </div>
                    </div>
                  </>
                ) : !_.isEmpty(filteredSlotsData) ? (
                  <>
                    {filteredSlotsData?.map((dayData, index) => {
                      console.log("dayData", dayData);
                      return (
                        <div className="listbox d-flex" key={index}>
                          <div className="date-box">
                            <div className="text-frame">
                              <span className="number-2">
                                {moment
                                  .unix(dayData.date_time)
                                  .tz(
                                    userDetailRes?.payload?.payload
                                      ?.timezoneAbbr
                                  )
                                  .format("DD")}
                              </span>
                              <span className="month-oct">
                                {" "}
                                {moment
                                  .unix(dayData.date_time)
                                  .tz(
                                    userDetailRes?.payload?.payload
                                      ?.timezoneAbbr
                                  )
                                  .format("MMM")}
                              </span>
                            </div>
                          </div>
                          <div className="datslot-box">
                            {Array.isArray(dayData.slot) &&
                            dayData.slot.length > 0
                              ? dayData.slot
                                  .sort((slotA, slotB) => {
                                    const timeA = slotA.start_time;
                                    const timeB = slotB.start_time;
                                    return timeA - timeB;
                                  })
                                  .map((slot, slotIndex) => {
                                    const isPastSlot = moment
                                      .unix(slot.end_time)
                                      .isBefore(moment());
                                    return (
                                      <button
                                        id={`slot-${slot.id}-${slot.is_booking}`}
                                        disabled={slot.is_booking || slot.is_locked || isPastSlot}
                                        key={slotIndex}
                                        className={`time-slot-btn ${getSlotClass(
                                          dayData,
                                          slot
                                        )} d-flex justify-content-between align-items-center gap-1`}
                                        onClick={() => {
                                          setLoader(true);
                                          if (slot.is_booking || isPastSlot) {
                                            return;
                                          }
                                          let isSlotPresent = activeSlot.some(
                                            (item) => item.id === slot.id
                                          );
                                          if (isSlotPresent) {
                                            let updatedSlots =
                                              activeSlot.filter(
                                                (item) => item.id !== slot.id
                                              );
                                            setActiveSlot(updatedSlots);
                                            scrollIntoViewWithOffset(
                                              "#checkout-button",
                                              50
                                            );
                                          } else {
                                            let slots = [];
                                            slots.push(slot);
                                            setActiveSlot(slots);
                                            scrollIntoViewWithOffset(
                                              "#checkout-button",
                                              50
                                            );
                                            // setSelectedSession({
                                            //   date: moment(dayData.date).format(
                                            //     "YYYY-MM-DD"
                                            //   ),
                                            //   displayDate: moment(
                                            //     dayData.date
                                            //   ).format("Do MMM, YYYY"),
                                            //   startTime: moment
                                            //     .unix(slot.start_time)
                                            //     .tz(
                                            //       userDetailRes?.payload?.payload
                                            //         ?.timezoneAbbr
                                            //     )
                                            //     .format("hh:mm a"),
                                            //   endTime: moment
                                            //     .unix(slot.end_time)
                                            //     .tz(
                                            //       userDetailRes?.payload?.payload
                                            //         ?.timezoneAbbr
                                            //     )
                                            //     .format("hh:mm a"),
                                            //   id: slot.id,
                                            // });
                                          }
                                        }}
                                        title={
                                          slot.self_booked
                                            ? t("Already booked by you")
                                            : ""
                                        }
                                      >
                                        {moment
                                          .unix(slot.start_time)
                                          .tz(
                                            userDetailRes?.payload?.payload
                                              ?.timezoneAbbr
                                          )
                                          .format("hh:mm a")}{" "}
                                        -{" "}
                                        {moment
                                          .unix(slot.end_time)
                                          .tz(
                                            userDetailRes?.payload?.payload
                                              ?.timezoneAbbr
                                          )
                                          .format("hh:mm a")}
                                        {slot.is_booking ? (
                                          <i
                                            className="fa fa-info-circle"
                                            title={"Already booked by you"}
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </button>
                                    );
                                  })
                              : t("noSlotsAvailable")}
                          </div>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <section className="error-box pt-0">
                    <img src="/images/pana.svg" alt="error-svg" />
                    <div className="error-msgs mb-0">
                      {t(
                        "Currently, no session available for this coach. Please select another or month to get started!"
                      )}
                    </div>
                  </section>
                )}
              </div>
            </div>
            {error && (
              <Form.Text className="text-danger d-flex justify-content-center ">
                {error}
              </Form.Text>
            )}
          </div>
          <div id="checkout-button"></div>
          <div className="sep"></div>
          <div className="d-flex footer-btn-card justify-content-between align-items-center gap-1">
            <div className="price-sec-xl">
              {selectedHours > 0 ? (
                <>
                  <b>
                    {currencyCode} {currencySymbol}
                    {sellingPrice}
                  </b>{" "}
                  {t("Total")} ({selectedHours} Hr{selectedHours > 1 ? "s" : ""}
                  )
                </>
              ) : (
                ""
              )}
            </div>
            <div className="d-flex gap-3">
              {showCancel && (
                <Button variant="primary" onClick={() => setShow(false)}>
                  {t("cancel")}
                </Button>
              )}

              {/* <FormButtonComponent
                isPrimary={true}
                leftIcon={""}
                rightIcon={<RightArrowIcon />}
                isDisabled={_.isEmpty(activeSlot)}
                btnName={
                  rescheduleFlag
                    ? t("Proceed to Reschedule")
                    : t("Proceed to Checkout")
                }
                btnAction={() => {
                  if (rescheduleFlag) {
                    rescheduleSlotsfunction(); // Call rescheduleSlots if rescheduleFlag is true
                  } else {
                    redirectTo(); // Call redirectTo otherwise
                  }
                }}
                showLoader={checkoutLoader}
                isPaymentButton={true}
              /> */}

              <FormButtonComponent
                isPrimary={true}
                leftIcon={""}
                rightIcon={<RightArrowIcon />}
                isDisabled={_.isEmpty(activeSlot)}
                btnName={
                  rescheduleFlag
                    ? t("Proceed to Reschedule")
                    : t("Proceed to Checkout")
                }
                btnAction={() => {
                  if (rescheduleFlag) {
                    rescheduleSlotsfunction(); // Call rescheduleSlots if rescheduleFlag is true
                  } else {
                    redirectTo(); // Call redirectTo otherwise
                  }
                }}
                showLoader={checkoutLoader}
                isPaymentButton={true}
              />
            </div>
          </div>
        </div>
      ) : (
        <CoachingServiceRequestForm
          priceInfo={priceInfo}
          selectedCoach={selectedCoach}
          activeSlot={activeSlot}
          preferredSlotData={preferredSlotData}
          setSelectedPreferredSlot={setSelectedPreferredSlot}
          redirectTo={redirectTo}
          errorMsg={errorMsg}
          setRemarks={setRemarks}
          remarks={remarks}
          checkoutLoader={checkoutLoader}
          selectedPreferredSlot={selectedPreferredSlot}
          dateError={dateError}
          selectedDate={selectedDate}
          selectedPreferredDate={selectedPreferredDate}
          setSelectedPreferredDate={setSelectedPreferredDate}
          remarksError={remarksError}
          serviceSlots={serviceSlots}
          selectedServiceSlot={selectedServiceSlot}
          setSelectedServiceSlot={setSelectedServiceSlot}
        />
      )}
      

      
    </>
  );
};

export default SlotBookingModal;
